const clean = (value) => String(value ?? '').trim().toLowerCase();

export const normalizeMeetingRole = (value) =>
  clean(value).replace(/[\s-]+/g, '_');

const RECORDING_MODERATOR_ROLES = new Set([
  'admin',
  'super_admin',
  'superadmin',
  'church_admin',
  'staff',
  'faculty',
]);

const DISMISSIBLE_RECORDING_ROLES = new Set([
  'admin',
  'super_admin',
  'superadmin',
  'church_admin',
  'staff',
]);

export const canDismissRecordingPrompt = (role) =>
  DISMISSIBLE_RECORDING_ROLES.has(normalizeMeetingRole(role));

export const isClassroomRecordingModerator = (role) =>
  RECORDING_MODERATOR_ROLES.has(normalizeMeetingRole(role));

export const isRoomRecordingActive = ({
  room,
  recording = false,
} = {}) => {
  const state = clean(room?.recordingDecision?.state);
  return (
    recording === true ||
    room?.isRecording === true ||
    state === 'recording'
  );
};

// Recording can be started from the meeting toolbar. Never interrupt class
// with a mandatory reminder, including old meetings without automatic policy.
export const shouldShowClassroomRecordingPrompt = () => false;
